import { useEffect } from 'react'
import { Link } from 'react-router-dom';
import FooterContact from '../../../component/FooterContact';
import HomeVideo2 from '../../../assets/images/banner/banner-1.mp4';

export default function DigitalRisk() {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            {/* Hero */}
            <section className="pad60 box-shadow innertopbanner" style={{ position: 'relative', overflow: 'hidden' }}>
                <div className="overlay-top-left"></div>
                <div className="container">
                    <div className="row align-items-center height100">
                        <div className="col-lg-7 col-md-12">
                            <div className="banner-caption">
                                <div itemScope itemType="http://schema.org/BreadcrumbList" className="breadcrumbs">
                                    <ul>
                                        <li itemProp="itemListElement" itemScope itemType="http://schema.org/ListItem">
                                            <Link to="/"><span itemProp="name">Home</span></Link>
                                            <meta itemProp="position" content="1" />
                                        </li>
                                        <li itemProp="itemListElement" itemScope itemType="http://schema.org/ListItem">
                                            <i className="icofont-thin-right"></i>
                                            <span itemProp="name">Digital Risk Protection</span>
                                            <meta itemProp="position" content="2" />
                                        </li>
                                    </ul>
                                </div>
                                <div className="prod-section-label">Digital Risk Protection</div>
                                <h1 className="prod-hero-title">Protecting Your <span>Digital Risk</span></h1>
                                <p>DRP is a cybersecurity practice centered on proactively detecting and addressing external threats that arise from an organization's digital footprint — across web, social media, and the dark web.</p>
                                <div className="button_services mt-4">
                                    <Link to="/contact"><button className="prod-cta-btn">Contact Us &nbsp;<i className="fa fa-arrow-right"></i></button></Link>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-5 col-md-12">
                            <div className="banner-mobiles text-center">
                                <img src={require('../../../assets/images/services/products/data-bg-transparant.webp')} alt="Digital Risk Protection" />
                            </div>
                        </div>
                    </div>
                </div>
                <video autoPlay loop muted style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', objectFit: 'cover', zIndex: -1 }}>
                    <source src={HomeVideo2} type="video/mp4" />
                </video>
            </section>

            {/* Overview */}
            <section className="prod-info-section" style={{ background: '#0a0a0a' }}>
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6">
                            <div className="prod-info-image">
                                <img src={require('../../../assets/images/services/products/Ransom.jpg')} alt="Digital Risk Protection" />
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="prod-info-content">
                                <div className="prod-section-label">Overview</div>
                                <h2>Comprehensive Digital Risk Protection</h2>
                                <p>Digital Risk Protection is a comprehensive security solution that provides digital risk management for your brand and customers. It's the only solution for all digital engagement channels — web domains, social media, and the deep and dark web.</p>
                                <p>We protect against: <strong style={{ color: '#ff6b35' }}>Third Party Risk, Reputational Risk, and Operational Risk</strong> — providing a holistic defense that revolutionizes digital risk management.</p>
                                <Link to="/contact" className="prod-cta-btn" style={{ marginTop: '12px', display: 'inline-flex' }}>
                                    Get Protected <i className="fa fa-arrow-right" style={{ marginLeft: 8 }}></i>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* 3 Monitoring Areas */}
            <section className="prod-highlight-section">
                <div className="container">
                    <div className="text-center mb-5">
                        <div className="prod-section-label" style={{ margin: '0 auto 16px' }}>Monitoring</div>
                        <h2 className="prod-section-title">Threat <span>Monitoring Capabilities</span></h2>
                        <p className="prod-section-sub" style={{ margin: '0 auto' }}>Continuous scanning across the far reaches of the digital world — millions of web pages, dark web, and social content</p>
                    </div>
                    <div className="prod-features-grid" style={{ paddingTop: 0 }}>
                        <div className="prod-feature-card">
                            <div className="prod-feature-icon"><i className="fa fa-map-marker"></i></div>
                            <h4>Location Threat Monitoring</h4>
                            <p>Gives instant notification of threats made against your location(s). Using geo-coordinates or explicit location information, it helps you protect and defend against physical and digital threats.</p>
                            <div className="prod-feature-number">01</div>
                        </div>
                        <div className="prod-feature-card">
                            <div className="prod-feature-icon"><i className="fa fa-trademark"></i></div>
                            <h4>Brand Threat Monitoring</h4>
                            <p>Monitors for threats targeting your organization and customers — including cyber threats, fraud, gun threats, protest activity, physical violence threats, and more across all digital channels.</p>
                            <div className="prod-feature-number">02</div>
                        </div>
                        <div className="prod-feature-card">
                            <div className="prod-feature-icon"><i className="fa fa-user-tie"></i></div>
                            <h4>Executive Threat Monitoring</h4>
                            <p>Find threats on social media, breach databases, and darknet sources. Detects reputation compromise and content with hate speech in conjunction with your key executives.</p>
                            <div className="prod-feature-number">03</div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Content Monitoring */}
            <section className="prod-info-section" style={{ background: '#0a0a0a' }}>
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6 order-lg-2">
                            <div className="prod-info-image">
                                <img src={require('../../../assets/images/services/products/Content Monitoring- Digital Risk.jpg')} alt="Content Threat Monitoring" />
                            </div>
                        </div>
                        <div className="col-lg-6 order-lg-1">
                            <div className="prod-info-content" style={{ paddingLeft: 0, paddingRight: 40 }}>
                                <div className="prod-section-label">Content Monitoring</div>
                                <h2>Content Threat Monitoring</h2>
                                <p>Monitor for threats against your brand, executives and locations. Our Digital Risk Protection continuously scans millions of web pages including the dark web and social content for threats targeting your organization.</p>
                                <ul className="prod-benefits-list mt-3">
                                    <li><span className="ben-dot">✓</span>Scan for malware, phishing, profanity, and hate speech</li>
                                    <li><span className="ben-dot">✓</span>Automatic log, notify, hide, or delete actions</li>
                                    <li><span className="ben-dot">✓</span>Most accurate content detection and classification</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Social & Domain Impersonation */}
            <section className="prod-dark-section">
                <div className="container">
                    <div className="text-center mb-5">
                        <div className="prod-section-label" style={{ margin: '0 auto 16px' }}>Impersonation Defense</div>
                        <h2 className="prod-section-title">Social &amp; Domain <span>Impersonation Protection</span></h2>
                        <p className="prod-section-sub" style={{ margin: '0 auto' }}>Attackers register many web domains and social media accounts to mimic legitimate businesses — defrauding employees, customers and partners</p>
                    </div>
                    <div className="prod-features-grid" style={{ paddingTop: 0 }}>
                        <div className="prod-feature-card">
                            <div className="prod-feature-icon"><i className="fa fa-globe"></i></div>
                            <h4>Domain Mapping</h4>
                            <p>Build a "known good" map of your brand-owned domains and social accounts to identify deviations and fraudulent registrations quickly.</p>
                        </div>
                        <div className="prod-feature-card">
                            <div className="prod-feature-icon"><i className="fa fa-search"></i></div>
                            <h4>Fraud Detection</h4>
                            <p>Gain visibility into fraudulent domains and social accounts impersonating your brand. Identify infringing use of your logos and brand assets across the web.</p>
                        </div>
                        <div className="prod-feature-card">
                            <div className="prod-feature-icon"><i className="fa fa-ban"></i></div>
                            <h4>Takedown Workflow</h4>
                            <p>Integrates with internal and third-party takedown workflows. Submit malicious domains to block lists and virtual takedown services automatically.</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* Social Media & DRP Actions */}
            <section className="prod-info-section" style={{ background: '#0a0a0a' }}>
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6">
                            <div className="prod-info-image">
                                <img src={require('../../../assets/images/services/products/social-media.jpg')} alt="Social Media Protection" />
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="prod-info-content">
                                <div className="prod-section-label">Social Media Protection</div>
                                <h2>Social Media Account Protection</h2>
                                <p>Social Media Account Protection defends your Facebook, Snapchat, Instagram, Twitter, and YouTube accounts with powerful tools and protection features.</p>
                                <div className="prod-numbered-list" style={{ marginTop: 16 }}>
                                    <div className="prod-step-item">
                                        <span className="prod-step-num">01</span>
                                        <div>
                                            <h4>Automate Content Remediation</h4>
                                            <p>Scan posts and comments for high-risk content. Decide whether to log, notify, hide, or delete — no other technology detects and classifies content more accurately.</p>
                                        </div>
                                    </div>
                                    <div className="prod-step-item">
                                        <span className="prod-step-num">02</span>
                                        <div>
                                            <h4>Detect Account Takeovers</h4>
                                            <p>Continuously monitor for changes in account profiles that can indicate a hack. Automatically revert compromised accounts to a "known good" state or lock them down.</p>
                                        </div>
                                    </div>
                                    <div className="prod-step-item">
                                        <span className="prod-step-num">03</span>
                                        <div>
                                            <h4>Enforce Publishing Policy</h4>
                                            <p>App policies enforce publishing access controls, reducing the risk of unapproved publishing and ensuring consistent use of approved content workflows.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* CTA */}
            <section style={{ background: '#0a0a0a', padding: '0 0 80px' }}>
                <div className="container">
                    <div className="prod-cta-banner">
                        <div>
                            <h3>Protect Your Digital Footprint Today</h3>
                            <p>Get a comprehensive digital risk assessment and protection strategy for your brand and organization.</p>
                        </div>
                        <Link to="/contact" className="prod-cta-btn">
                            Get Protected <i className="fa fa-arrow-right" style={{ marginLeft: 8 }}></i>
                        </Link>
                    </div>
                </div>
            </section>

            <FooterContact />
        </>
    )
}
